<template>
  <el-container>
    <el-header style="height: 35px; border-bottom: 1px solid #eee">
      <el-row type="flex" justify="center" align="middle">
        <el-checkbox size="mini" v-model="onlyMine" @change="queryHelp()">只看我自己的</el-checkbox>
        <el-input size="mini" class="condition-wide left-pad" type="text" clearable placeholder="关键字" v-model="condition.keyword" @keyup.enter.native="queryHelp(condition.keyword)" @clear="queryHelp()">
          <el-row slot="append">
            <el-button @click="queryHelp(condition.keyword)" :disabled="loading" icon="el-icon-search" size="mini"> </el-button>
            <el-button @click="addHelp" :disabled="loading" icon="el-icon-plus" size="mini" title="选择内容并输入关键字后点击添加"></el-button>
          </el-row>
        </el-input>
      </el-row>
    </el-header>
    <el-main style="position: absolute; top: 35px; bottom: 0px; left: 0; right: 0">
      <el-row v-for="(item, index) in words" :key="index">
        <el-alert type="info" class="bottom-pad" :closable="false" style="font-size: 14px">
          <el-row slot="title">
            {{ item.name }}
            <el-link type="primary" icon="el-icon-edit" @click="editHelp(item)" class="left-pad" v-if="item.doctorCode == user.code"></el-link>
            <el-popconfirm title="确认要删除吗？" @confirm="delHelp(item)">
              <el-button slot="reference" type="text" icon="el-icon-delete" size="mini" class="left-pad danger" v-if="item.doctorCode == user.code"></el-button>
            </el-popconfirm>
          </el-row>
          <el-link type="info" size="small" icon="el-icon-edit-outline" @click="quotaHelp(item)" class="right-pad" :underline="false">
            {{ item.content }} <small>【{{ item.doctorName || "匿名" }}】 引用 {{ item.times }} 次</small>
          </el-link>
        </el-alert>
      </el-row>
    </el-main>
    <HelpEditor v-model="editingWord" :visible.sync="editorShow"></HelpEditor>
  </el-container>
</template>
<script>
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      tmpl: Object,
    },
    components: {
      HelpEditor: () => import("../help/edit"),
    },
    data() {
      return {
        loading: false,
        onlyMine: true,
        condition: {
          doctorCode: null,
          keyword: null,
        },
        words: [],
        editingWord: null,
        editorShow: false,
      };
    },
    computed: {
      ...mapGetters(["user"]),
    },
    mounted() {
      // 通过此方法把编辑器的 editor 带过来
      this.$bus.$on("IDE-HELP-INPUT-READY", (e) => {
        this.$editor = e;
      });
      this.$bus.$on("IDE-HELP-INPUT-QUERY", this.queryHelp);
    },
    unmounted() {
      this.$bus.$off("IDE-HELP-INPUT-READY");
      this.$bus.$off("IDE-HELP-INPUT-QUERY", this.queryHelp);
    },
    methods: {
      queryHelp(keyword) {
        if (this.tmpl?.gender) {
          this.condition.genders = ["不限", this.tmpl.gender];
        }
        this.condition.deptCode = this.user.deptCode;
        if (this.onlyMine) {
          this.condition.doctorCode = this.user.code;
        } else {
          this.condition.doctorCode = null;
        }
        this.condition.scope = this.tmpl?.scope; // 门诊或住院
        if (keyword) {
          this.condition.keyword = keyword.split("-")[0];
        } else {
          this.condition.keyword = null;
        }

        this.condition.sort = "times";
        this.condition.asc = false;
        this.$api.Help.query(this.condition)
          .then((res) => {
            this.words = res.items;
          })
          .catch((err) => {
            console.log(err);
          });
      },
      addHelp() {
        if (!this.condition.keyword) {
          this.$message.warning("请在搜索框中输入关键字后才能添加!");
          return;
        }
        var oRet = this.$editor.GetSelectText();
        let txt = oRet.Text.replace("\r\n", "");
        if (!txt) {
          this.$message.warning("请先选中文本后再点击【添加】按钮！");
          return;
        }
        this.$api.Help.save({
          keyword: this.condition.keyword,
          content: txt,
          mrRange: "个人",
          scope: this.tmpl.scope,
          category: this.tmpl.category,
          gender: this.tmpl.gender,
          name: txt.length > 5 ? txt.substr(0, 15) + "..." : txt,
          deptCode: this.user.deptCode,
          doctorCode: this.user.code,
          doctorName: this.user.name,
          times: 0,
        })
          .then((res) => {
            this.words.push(res);
          })
          .catch((err) => {
            this.$message.error(err);
          });
      },
      editHelp(item) {
        this.editingWord = this.$utils.Obj.clone(item);
        this.editorShow = true;
      },
      quotaHelp(item) {
        this.$editor.InsertText(item.content, 0);
        this.$api.Help.times(item.id);
      },
      delHelp(item) {
        this.$api.Help.del(item.id)
          .then((res) => {
            this.$message.success("删除成功!");
            this.words = this.words.filter((w) => w.id != item.id);
          })
          .catch((err) => {
            this.$message.error(err);
          });
      },
    },
  };
</script>
